import TrackingService from 'app/services/tracking/tracking.service';
import SectionLookupService from "external-services/section-lookup-service/sectionLookup.service";
import SectionGroupsService from "external-services/section-groups-service/sectionGroups.service";

const NS = 'EditSectionGroupCtrl';

export default function EditSectionGroupCtrl(
  $log, $mdDialog, $filter, sectionGroup, highestOrder
) {
  "ngInject";

  TrackingService.trackPageView('settings.section-group.edit');

  const vm = this;
  //-- define public properties
  vm.sectionGroup = {};
  vm.groupSections = [];
  // states
  vm.LOADING = 1;
  vm.ENTER = 0;
  vm.SUCCESS = 2;
  vm.ERROR = 3;
  vm.state = vm.LOADING;
  //-- define public methods
  vm.cancel = cancel;
  vm.save = save;
  vm.addSection = addSection;
  vm.removeSection = removeSection;

  if (sectionGroup) {
    vm.sectionGroup = sectionGroup;
  } else {
    var order = highestOrder + 1;
    vm.sectionGroup.order = order;
  }

  getSections();

  function getSections() {
    SectionLookupService.getSections().then(function (sections) {
      vm.sections = $filter('orderBy')(sections, 'order');
      if (sectionGroup) {
        vm.sectionGroup = sectionGroup;
        for (var i = vm.sections.length - 1; i >= 0; i--) {
          var section = vm.sections[i];
          if (vm.sectionGroup.sectionIds.indexOf(section._id) !== -1) {
            addSection(section);
          }
        }
      }
      vm.state = vm.ENTER;
    }).catch(function (err) {
      $log.error('sections failed to load', err);
    });
  }

  function removeSection(section) {
    var groupIndex = sectionGroupIndex(section._id);
    if (groupIndex !== false) {
      vm.groupSections.splice(groupIndex, 1);
    }
  }

  function addSection(section) {
    var groupIndex = sectionGroupIndex(section._id);
    if (groupIndex === false) {
      vm.groupSections.push(section);
    }
  }

  function sectionGroupIndex(sectionId) {
    for (var i = vm.groupSections.length - 1; i >= 0; i--) {
      var section = vm.groupSections[i];
      if (sectionId === section._id) {
        return i;
      }
    }
    return false;
  }

  function cancel() {
    $mdDialog.hide();
  }

  function save(isValid) {
    if (isValid) {
      vm.state = vm.LOADING;
      // add section ids
      var sectionIds = vm.groupSections.map(function (section) {
        return section._id;
      });
      vm.sectionGroup.sectionIds = sectionIds;

      SectionGroupsService.saveSectionGroup(vm.sectionGroup).then(function () {
        vm.state = vm.SUCCESS;
        $mdDialog.hide();
      }).catch(function (err) {
        $log.error('Section group failed to save', err);
        vm.state = vm.ENTER;
      });
    } else {
      vm.displayErrors = true;
    }
  }
}
